import { Box, Button, Heading, Text } from "@cruk/cruk-react-components";
import { useOptimizelyContext } from "@fwa/src/contexts/OptimizelyContext";
import { useTracking } from "@fwa/src/hooks/useTracking";

export const CogCta = () => {
  const { trackEventGtm } = useTracking();
  const { trackEventOptimizely } = useOptimizelyContext();

  return (
    <Box backgroundColor="primary" padding="s">
      <Heading h2 textSize="l" textColor="text-on-primary">
        Want to help us power more progress?
      </Heading>
      <Text textColor="text-on-primary">
        Regular giving helps us to plan for the future, so we can fund more
        life-saving work.
      </Text>
      <a
        href="https://donate.cancerresearchuk.org/support-us/your-donation?type=regular"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          trackEventOptimizely({ eventKey: "of_cog_signup_click" });
          trackEventGtm({
            event: "donate_cta",
            cta: "cog",
          });
        }}
        data-cta-type="donate-cog"
      >
        <Button full>Donate Monthly</Button>
      </a>
    </Box>
  );
};

export default CogCta;
